function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#f7cc8f",
  d: "M23.07 55.07L17 61.14a3 3 0 01-4.24 0l-9.9-9.9a3 3 0 010-4.24l6.07-6.07z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#c2cde7",
  d: "M61.43 28l-4.24 4.24a2 2 0 01-2.83 0L31.73 9.64a2 2 0 010-2.83L36 2.57a2 2 0 012.83 0l22.6 22.63a2 2 0 010 2.8z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#d6dff2",
  d: "M61.43 28l-2.2 2.2L33.77 4.77 36 2.57a2 2 0 012.83 0l22.6 22.63a2 2 0 010 2.8z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#f9dd8f",
  d: "M43.64 34.51L23.07 55.07 17 61.14a3 3 0 01-4.24 0l-9.9-9.9a3 3 0 010-4.24l6.07-6.07 20-20z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#f7cc8f",
  d: "M28.9 21l-.3.3 10.06 9.26-20.57 20.51L12 57.14a3 3 0 01-2.39.86l3.15 3.15a3 3 0 004.24 0l6.07-6.07 20.57-20.57z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#f9e3ae",
  d: "M6.86 55.22a3 3 0 010-4.24l6.07-6.07 20-20 10.58 9.74.16-.16L28.9 21l-20 20-6.04 6a3 3 0 000 4.24l9.9 9.9.1.08z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#acb7d0",
  d: "M31.73 9.64a10 10 0 000 14.14L36 28l7 7c3.64 1 8.46.17 11.36-2.73z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#ed7899",
  d: "M27.076 31.271a4 4 0 105.657 5.657 4 4 0 10-5.657-5.657z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#c2cde7",
  d: "M23.13 55L9 40.87A2 2 0 019 38a2 2 0 012.83 0L26 52.19A2 2 0 0126 55a2 2 0 01-2.87 0zM26 36l-3 3 2 2 3-3z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#8d6c9f",
  d: "M62.14 24.49L39.51 1.86a3.07 3.07 0 00-4.24 0L31 6.1a3 3 0 00-.56 3.45 11 11 0 00-2.1 10.59 1 1 0 00-.16.11L11.69 36.76a3 3 0 00-4 4l-5.53 5.53a4 4 0 000 5.66L12 61.84a4 4 0 005.66 0l5.53-5.53a3.08 3.08 0 001.3.29 3 3 0 002.7-4.29L43.9 35.65a10.9 10.9 0 0010.55-2.12A3 3 0 0057.9 33l4.24-4.24a3 3 0 000-4.24zM16.3 60.43a2 2 0 01-2.83 0l-9.9-9.9a2 2 0 010-2.83L9 42.29 21.72 55zm9-6.12a.46.46 0 00-.07.07 1 1 0 01-1.35-.07l-.7-.7L10.4 40.88l-.71-.71a1 1 0 01-.13-1.27.46.46 0 01.07-.07.35.35 0 01.14-.14.46.46 0 01.07-.07 1 1 0 011.26.13l.71.71 12.73 12.73.71.71a1 1 0 01.07 1.34.46.46 0 00-.07.07zM44 33.58a1 1 0 00-.34-.06h-.1a1 1 0 00-.27.06 1 1 0 00-.13.08 1 1 0 00-.19.13l-17 17L13.23 38l16-16A11 11 0 0031 24.49l4.41 4.41a1 1 0 001.41-1.41l-4.41-4.41a9 9 0 01-.67-12l10.6 10.58 10.57 10.57A9 9 0 0144 33.58zm16.71-6.26l-4.24 4.24a1 1 0 01-1.41 0L32.44 8.93a1 1 0 010-1.41l4.24-4.24a1 1 0 011.41 0L60.72 25.9a1 1 0 010 1.41z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#8d6c9f",
  d: "M43.05 12.48l-1.41 1.41a1 1 0 101.41 1.41l1.41-1.41a1 1 0 00-1.41-1.41zM46.59 16l-1.41 1.41a1 1 0 101.41 1.41L48 17.43A1 1 0 0046.59 16zm3.54 3.55L48.71 21a1 1 0 101.41 1.41L51.54 21a1 1 0 00-1.41-1.41zm3.53 3.53l-1.41 1.42a1 1 0 101.41 1.41l1.41-1.41a1 1 0 00-1.41-1.41zm3.54 3.54L55.78 28a1 1 0 101.41 1.41L58.61 28a1 1 0 00-1.41-1.41zM36 5.41l-1.43 1.41A1 1 0 1036 8.23l1.4-1.41A1 1 0 0036 5.41zm3.52 3.53l-1.42 1.42a1 1 0 101.41 1.41l1.41-1.41a1 1 0 00-1.41-1.41zM29.9 29.1a4.94 4.94 0 00-3.53 1.46A5 5 0 0025 34.8L22.71 37A3 3 0 1027 41.29L29.2 39a5.49 5.49 0 00.7 0 5 5 0 100-10zm-4.36 10.77a1 1 0 01-1.41-1.41l1.6-1.61a5.31 5.31 0 00.64.78 4.28 4.28 0 00.78.64zM32 36.22a3 3 0 01-3.4.56 2.9 2.9 0 01-1.41-1.41 3 3 0 01.56-3.4A3 3 0 0132 31.9v.1l.07.08a3 3 0 010 4.15zm7.68-5.9a1 1 0 00-1.41 1.41l1.41 1.41a1 1 0 001.41-1.41z"
});

function SvgFlashlight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

export default SvgFlashlight;